// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3BSVf","col":"styles_col__2QfwF"};